const DNI_REGEX = {
  AR: /^\d{7,9}$/,
  ES: /^(\d{8})([A-Z])$/i,
  DEFAULT: /^\d{9}$/,
}

export function isValidDNI(value, nationalityId = null) {
  const pattern = DNI_REGEX[nationalityId] || DNI_REGEX.DEFAULT
  return pattern.test(value)
}
